import { NewsList } from './Components/NewsList';
import { blogs } from './constants';
import s from './style.module.scss';

export const Section4 = (): JSX.Element => {
  return (
    <div className={`${s.container}`}>
      <div className={s.wrapContainer}>
        <div className={s.title}>The press loves us too.</div>
        <NewsList data={blogs} />
      </div>
    </div>
  );
};
